(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .config(customThemingProvider);

  /** @ngInject */
  function customThemingProvider($mdThemingProvider, brand){

    $mdThemingProvider.definePalette('r2w', {
      '50': 'e1f5fe',
      '100': 'b3e5fc',
      '200': '81d4fa',
      '300': '4fc3f7',
      '400': '29b6f6',
      '500': '03a9f4',
      '600': '03a2f3',
      '700': '0298f1',
      '800': '028fef',
      '900': '017eec',
      'A100': 'ffffff',
      'A200': 'FF9800', // Orange
      'A400': 'add4ff',
      'A700': 'FF9800', // Orange on mouseover
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });
    $mdThemingProvider.definePalette('karcher', {
      '50': 'ececec',
      '100': 'd1d1d1',
      '200': 'b2b2b2',
      '300': '939393',
      '400': '7b7b7b',
      '500': '646464',
      '600': '5c5c5c',
      '700': '525252',
      '800': '484848',
      '900': '363636',
      'A100': 'f49a9a',
      'A200': '646464', // Default theme color instead #ef6c6c
      'A400': 'ff2929',
      'A700': '646464', // Default theme color for mouseover instead #ff0f0f
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [],
      'contrastLightColors': []
    });

    $mdThemingProvider.theme('default')
      .primaryPalette(brand)
      .warnPalette('red')
      .accentPalette(brand);
  }
})();
